import { loadComponents } from '@ampcore/react-to-web-component'
import { componentRegistry } from './component-registry'

declare global {
  interface Window {
    loadComponents: () => void
  }
}

// eslint-disable-next-line no-undef
const componentObserver = new MutationObserver(() =>
  loadComponents(componentRegistry)
)

componentObserver.observe(document.body, {
  childList: true,
  subtree: true
})

document.addEventListener('DOMContentLoaded', () =>
  loadComponents(componentRegistry)
)

// Make function available to reload components externally
window.loadComponents = () => loadComponents(componentRegistry)
